import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/home/homev2_bottom_bg.png'
import _imports_1 from '@/assets/home/homev2_bottom_icon_77.png'
import _imports_2 from '@/assets/home/homev2_bottom_icon_download.png'
import _imports_3 from '@/assets/common/logo_688v.png'


const _hoisted_1 = { class: "panel_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { goToLink } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'downloadPanel',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const iosData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const androidData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const customStyle = ref({
    color: ""
})
const props = __props

onMounted(() => {
    iosData.value.url = props.itemData.ios.url
    iosData.value.display = props.itemData.ios.display
    iosData.value.redirect_url = props.itemData.ios.redirect_url
    iosData.value.text = props.itemData.ios.text

    androidData.value.url = props.itemData.android.url
    androidData.value.display = props.itemData.android.display
    androidData.value.redirect_url = props.itemData.android.redirect_url
    androidData.value.text = props.itemData.android.text

    customStyle.value.color = props.itemData.styles.color
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bottom_icon" }, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: ""
      })
    ], -1)),
    _createVNode(_component_van_row, { class: "btn_section" }, {
      default: _withCtx(() => [
        (iosData.value.display)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 0,
              span: "12",
              class: "download_item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: iosData.value.url,
                  alt: ""
                }, null, 8, _hoisted_2),
                _createElementVNode("div", {
                  class: "download_btn",
                  style: _normalizeStyle({ color: customStyle.value.color, border: `1px solid ${customStyle.value.color}` }),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToLink)(iosData.value.redirect_url)))
                }, _toDisplayString(iosData.value.text), 5)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (androidData.value.display)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 1,
              span: "12",
              class: "download_item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: androidData.value.url,
                  alt: ""
                }, null, 8, _hoisted_3),
                _createElementVNode("div", {
                  class: "download_btn",
                  style: _normalizeStyle({ color: customStyle.value.color, border: `1px solid ${customStyle.value.color}` }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToLink)(androidData.value.redirect_url)))
                }, _toDisplayString(androidData.value.text), 5)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { class: "bottom_section" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "14",
          class: "transfer_btn"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_2,
              alt: ""
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('home.transfer')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "10",
          class: "logo"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: _imports_3,
              alt: ""
            }, null, -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})